import { useContext } from "react";
import { RenterDashboardContext } from "./RenterDashboard.context";

export function useRenterDashboardContext() {
    const context = useContext(RenterDashboardContext)

    if (!context) {
        throw new Error("useRenterDashboardContext deve ser utilizado apenas dentro de RenterDashboardProvider")
    }

    return context
}